// Mixin compartido para pollear el estado LOCAL de una solicitud de hoja de vida
// (conductor o vehículo) contra /consultar_estado_solicitud_hv — este endpoint
// NO consume la API externa de Seway, solo lee el estado registrado por el
// webhook de callback (o por la última respuesta guardada localmente).
//
// El componente que use este mixin debe implementar, según aplique:
//   onSolicitudHvCompletada()      -> se llama al detectar estado COMPLETADO
//   onSolicitudHvError(mensaje)    -> se llama al detectar estado ERROR
//   onSolicitudHvTimeout()         -> se llama si se agotan los intentos de polling

export default {
  data() {
    return {
      pollingTimer: null,
      pollingIntento: 0,
      pollingMax: 30, // ~7.5 min a 15s por intento (barato: no consume la API externa)
    };
  },

  beforeUnmount() {
    this.detenerPollingSolicitudHv();
  },

  methods: {
    iniciarPollingSolicitudHv(tipo, identificador) {
      this.detenerPollingSolicitudHv();
      this.pollingIntento = 0;

      this.pollingTimer = setInterval(() => {
        this.pollingIntento++;

        if (this.pollingIntento > this.pollingMax) {
          this.detenerPollingSolicitudHv();
          if (typeof this.onSolicitudHvTimeout === 'function') this.onSolicitudHvTimeout();
          return;
        }

        window.api.call('post', '/consultar_estado_solicitud_hv', { tipo, identificador })
          .then((res) => {
            if (res.status !== 200) return;
            const { estado, mensaje } = res.data;

            if (estado === 'COMPLETADO') {
              this.detenerPollingSolicitudHv();
              if (typeof this.onSolicitudHvCompletada === 'function') this.onSolicitudHvCompletada();
            } else if (estado === 'ERROR') {
              this.detenerPollingSolicitudHv();
              if (typeof this.onSolicitudHvError === 'function') this.onSolicitudHvError(mensaje);
            }
          })
          .catch(() => { /* polling silencioso */ });
      }, 15000);
    },

    detenerPollingSolicitudHv() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
  },
};
